import {
  SET_SELECTED_STATUS, SET_SEARCH_TEXT, SET_CATALOGO, CLEAR_FILTERS,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_CATALOGO](state, catalogo) {
    state.catalogo = catalogo;
  },
  [CLEAR_FILTERS](state) {
    state.catalogo = null;
  },
};
